<template>
  <transition name="fade" mode="out-in">
    <base-card>
      <div class="flex-container">
        <div class="flex-child">
          <h5 class="search-txt">Fairfield Tennis Courts&nbsp;:&nbsp;&nbsp;Select date availability</h5>
        </div>
        <div v-if="allowRecursive" class="flex-child">
          <base-toggle
            class="custom-button toggle"
            @booking-type="changeBookingType"
          >
          </base-toggle>
        </div>
      </div>

      <div v-if="allowRecursive && bookingType !== 'causal'">
        <p class="form-note">
          To make a weekly booking, please select dates Monday to Friday (1
          week)
        </p>
      </div>

      <form @submit.prevent="submitSearch">
        <div class="">
          <label for="startDatelbl">Date : </label>
          <input
            id="startDate"
            name="startDate"
            type="date"
            ref="startDate"
            dateformat="dd/MM/yyyy"
            v-model="startDate"
            :min="minDate"
            :max="maxDate"
            required
          />
        </div>

        <div
          class=""
          v-if="allowRecursive && this.bookingType !== 'causal'"
        >
          <label for="endDatelbl">To Date : </label>
          <input
            id="endDate"
            name="endDate"
            type="date"
            ref="endDate"
            dateformat="dd/MM/yyyy"
            v-model="endDate"
            :min="minDate"
            :max="maxDate"
            required
          />
        </div>
        <form v-if="!dailyOnly">
          <div class="">
            <label for="time">Start time : </label>
            <time-picker
              format="hh:mm a"
              class="time-picker"
              placeholder="Pick a time"
              auto-scroll
              :hour-range="hourOpts"
              :minute-interval="30"
              @change="timePickerHandler"
            ></time-picker>
          </div>
          <div class="" v-if="!dailyOnly">
            <label for="durationlbl"> How many hours : </label>
            <select v-model="selectedOption" @change="changeDuration" required>
              <option v-for="item in options" :key="item.value">
                {{ item }}
              </option>
            </select>
          </div>
        </form>
        <div class="">
          <label for="eventPaxlbl">How many people : </label>
          <input
            class="pax_input"
            type="number"
            id="eventPax"
            name="eventPax"
            ref="eventPax"
            min="1"
            maxlength="2"
            size="2"
            v-model="eventPax"
          />
        </div>

        <br />
        <div>
          <base-button class="button-search" v-if="!slots">Search</base-button>
          <base-button v-else class="button-search" disabled>Please select from the slots below</base-button>
        
        </div>
      </form>
    </base-card>
  </transition>
</template>

<script>
import { DefaultBookingType, DefaultBookingStatus } from '../data';
import BaseCard from '../UI/BaseCard.vue';
import BaseToggle from '../UI/BaseToggle';

import TimePicker from 'vue3-timepicker/src/VueTimepicker.vue';

function dateFormJoiner(date) {
  const dateStr = String(date);
  const dateParts = dateStr.split('-');
  //  console.log(date, dateStr);
  const newDateStr = dateParts[2] + '/' + dateParts[1] + '/' + dateParts[0];

  return newDateStr;
}

export default {
  components: { BaseCard, BaseToggle, TimePicker },
  emits: ['search-submit'],
  props: ['dailyOnly', 'allowRecursive', 'slots'],

  data() {
    return {
      bookingType: 'causal',
      showRecursive: false,
      numberOfDays: 1,
      currentRoute: '',

      minDate: '2021-12-01',
      maxDate: '2022-11-01',
      isLoading: false,
      inputInvalid: false,
      isLoaded: false,
      eventTypes: [],

      startDate: null,
      endDate: null,
      startTime: '',
      startHour: '07:00',
      endTime: '19:00',
      eventPax: 4,
      fieldOpeningHour: 7,
      fieldCloseHour: 22,
      duration: 60,
      totalSlotAvailable: 0,

      options: [1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8],  // KI 14Jul2022. Added 3.5.
      //options: [60, 90, 120, 150, 180, 240],
      selectedOption: 1,

      slotOpts: [],
      slotSelected: ' ',
      hourSelected: ' ',
      minuteSelected: ' ',
      hourOpts: [],
      units: 0,
      pickStartHour: null,
      pickStartMinute: null,

      afterhour: false,

      //  slotToBeConfirmed: null
    };
  },

  watch: {
    pickStartHour() {
      this.testingAfterHour();
    },

    pickStartMinute() {
      this.testingAfterHour();
    },

    selectedOption() {
      this.testingAfterHour();
    },
    bookingType() {
      this.resetDate();
    },

    allowRecursive() {
      this.$forceUpdate();
      this.showRecursive = this.allowRecursive;
    },
    startDate() { // KI 14Jul2022. Added one = to make !==
      //multiple changes by FCHQ staff therefore those needs to be reviewed
      if (this.dailyOnly || this.bookingType !== 'causal') {
        this.startTime = '07:00';
        this.endTime = '19:00';
      }
    },
    minDate() {},
  },

  mounted() {
    this.currentRoute = this.$router.currentRoute;
    if (this.currentRoute.path.toLowerCase().indexOf('fchq') >= 0) {
      this.fieldOpeningHour = 7;
      this.fieldCloseHour = 19;
      this.isfacility = false;
      this.eventPax = 1;
    }
    
    if(this.currentRoute.path.includes('whitlam')) {
      this.isWhitlam = true
      this.isfacility = false;
      this.eventPax = 1;
    }
    this.getMinDate();
    this.getMaxDate();

    this.generateTimeOptions();

    this.$eventBus.on('resetSession', () => {
      // DO NOT RESET this.endTime , system handle itself
      this.startTime = '07:00';
      this.duration = 60;
      this.startDate = null;
      this.endDate = null;
      this.selectedOption = 1;
    });

    this.$eventBus.on('search-again', () => this.resetDate());
  },

  methods: {
    resetDate() { // KI 14Jul2022. Added one = to make ===
      if (this.bookingType === 'causal' || !this.allowRecursive) {
        this.endDate = this.startDate;
        this.numberOfDays = 1;
      } else {
        this.startTime = '07:00';
        this.endTime = '19:00';
      }
    },

    getNumberOfDays(startDate, endDate) {
      let start = Date.parse(startDate);
      let end = Date.parse(endDate);

      let numberOfDays = (end - start) / 1000 / 3600 / 24;

      // special case, is afterhour. when over 8 hour and ending 5:30 or after

      return numberOfDays;
      //  console.log('number of days', this.numberOfDays);
    },

    changeBookingType(ev) {
      this.bookingType = ev;
    },

    getMinDate() {
      const today = new Date();
      let ystr = today.getFullYear();
      let mstr = this.stringToolPadding(today.getMonth() + 1);
      let dstr = this.stringToolPadding(today.getDate());

      this.minDate = ystr + '-' + mstr + '-' + dstr;
    },

    getMaxDate() {
      let maxDate = new Date();
      maxDate.setDate(maxDate.getDate() + 364);
      let ystr = maxDate.getFullYear();
      let mstr = this.stringToolPadding(maxDate.getMonth() + 1);
      let dstr = this.stringToolPadding(maxDate.getDate());

      this.maxDate = ystr + '-' + mstr + '-' + dstr;
    },

    stringToolPadding(myVar) {
      let str = '' + myVar;

      if (myVar < 10) {
        str = '0' + myVar;
      }

      return str;
    },

    changeDuration() {
      this.duration = (parseFloat(this.selectedOption) * 10 * 60) / 10;

      let _durationToUnits = this.duration / 30;

      let _endTimeUnits = this.units + _durationToUnits;

      this.calculateEndTime(_endTimeUnits);
    },

    hourToHourFormat(numb) {
      var _numb = numb;
      if (_numb < 10) {
        _numb = '0' + _numb;
      }

      return _numb;
    },

    calculateEndTime(units) {
      let maxUnits = this.fieldCloseHour * 2;
      let minimalOrder = maxUnits - this.units;
      if (minimalOrder < 2) {
        return;
      }

      if (units > maxUnits) {
        units = maxUnits;
      }

      let hourUnits = parseInt(units / 2);
      let minuteUnit = units % 2;
      // KI 14Jul2022. Added one = to make ===
      let minuteStr = minuteUnit === 1 ? '30' : '00';

      this.endTime = this.hourToHourFormat(hourUnits) + ':' + minuteStr;
    },

    testingAfterHour() {  // KI 14Jul2022. Added one = to make ===
      if (
        ((this.pickStartHour > 9 ||
          (this.pickStartHour === 9 && this.pickStartMinute === 30)) &&
          this.selectedOption >= 7) ||
        ((this.pickStartHour > 13 ||
          (this.pickStartHour === 13 && this.pickStartMinute === 30)) &&
          this.selectedOption >= 4)
      ) {
        //this.afterhour = true;
        this.afterhour = false; //M.A 2/02/23 - Changed this to false because it appears that afterhour is breaking...something?        
      } else {
        this.afterhour = false;
      }

      // console.log('this', this.afterhour);
    },

    calculateStartTime(_pickStart, _pickMinute) {
      if (_pickStart < this.fieldOpeningHour)
        _pickStart = this.fieldOpeningHour;

      this.units = _pickStart * 2;
      if (_pickMinute > 0) this.units = this.units + 1;

      this.startTime =
        this.hourToHourFormat(_pickStart) +
        ':' +
        this.stringToolPadding(_pickMinute);
    },

    timePickerHandler(eventData) {
      // console.log('hereereerere', eventData);

      this.pickStartHour = parseInt(eventData.data.HH);
      this.pickStartMinute = parseInt(eventData.data.mm);

      this.calculateStartTime(this.pickStartHour, this.pickStartMinute);

      let _durationToUnits = this.duration / 30;

      this.calculateEndTime(this.units + _durationToUnits);

      // if picked time is =9:30 or hh > 9 and pick optin is 8
      // fulltime event = true

      //   console.log('eventData', eventData, this.selectedOption);
    },
    generateTimeOptions() {
      this.hourOpts = [''];

      for (
        let hour = this.fieldOpeningHour;
        hour < this.fieldCloseHour;
        hour++
      ) {
        this.hourOpts.push(hour);
      }

      // if endhour greater than this.fieldCloseHour, endhour = this.fieldCloseHour
    },

    generateBookingDateObject(startDate, numberOfDays) {
      // this.getNumberOfDays(this.startDate, this.endDate);
      let dates = [];

      let factor = 1000 * 3600 * 24;
      let _startDT = new Date(Date.parse(startDate));
      // let endDT = new Date();
      for (let i = 1; i <= this.numberOfDays; i++) {
        let _endDT = new Date(Date.parse(_startDT) + factor);
        let dateStr =
          _startDT.getDate() +
          '/' +
          (_startDT.getMonth() + 1) +
          '/' +
          _startDT.getFullYear();

        if (numberOfDays > 1) {
          this.startTime = '07:00';
          this.endTime = '19:00';
        }

        let dateObject = {
          StartDate: dateStr + ' ' + this.startTime,
          EndDate: dateStr + ' ' + this.endTime,
        };
        dates.push(dateObject);
        _startDT = _endDT;
      }

      return dates;
    },

    submitSearch() {
      let maxUnits = this.fieldCloseHour * 2;
      let minimalOrder = maxUnits - this.units;
      if (minimalOrder < 2) {
        //   console.log(' minimal order is 60 minutes', maxUnits, this.units);
        this.$emit('search-submit', null);
        return;
      }

      if (this.bookingType === 'causal') { // KI 14Jul2022. Added one = to make ===
        this.endDate = this.startDate;
        this.numberOfDays = 1;
      } else {
        this.numberOfDays =
          this.getNumberOfDays(this.startDate, this.endDate) + 1;
      }

      var _startDate = dateFormJoiner(this.startDate); //this.startDate.replaceAll('-', '/');
      var _endDate = dateFormJoiner(this.endDate); //this.startDate.replaceAll('-', '/');
      
      var endTime = new Date( new Date(this.endDate + ' ' + this.endTime) - 1000 * 60 ).toLocaleTimeString('en-US', {
            // en-US can be set to 'default' to use user's browser settings
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
      })
      const slotObject = {
        StartDate: _startDate + ' ' + this.startTime,
        EndDate: _endDate + ' ' + endTime,
        VenueEndTime: _endDate + ' ' + this.endTime,
        VenuePax: this.eventPax, // 0 or 1000 makes not different therefore use 0

        VenueBookingType: DefaultBookingType,
        VenueBookingStatus: DefaultBookingStatus,

        NumberOfDays: this.numberOfDays,
        AfterHour: this.afterhour,
        Dates: this.generateBookingDateObject(
          this.startDate,
          this.numberOfDays
        ),
      };

      /*
      console.log(
      
        slotObject,
        this.startDate,
        this.endDate,
        this.numberOfDays
      );
*/
      this.$emit('search-submit', slotObject);
      this.$eventBus.emit('search-submit', []);
    },
  },
};
</script>

<style scoped>
select,
option {
  font: inherit;
  padding: 0.15rem;
  border: 1px solid #ccc;
}

select {
  width: 10rem;
}

.form-note {
  margin-left: 5rem;
  margin-top: -2rem;
  font-style: italic;
}

.button-search {
  margin-left: 0.5rem;
  margin-bottom: 1rem;
}

.time-picker,
.custom-button,
input,
select {
  /* font-family: inherit; */
  font-size: inherit;
  float: right;
  width: 200px;
  margin-right: 10rem;
  margin-bottom: 0.5rem;
  padding: auto;
}

.custom-button,
input,
select {
  border: 1px solid #ccc;
}

.time-picker {
  border: 2px solid #fff;
}

.vue__time-picker-dropdown {
  z-index: 5000;
}

.time-picker,
input,
select {
  height: 2.2rem;
}

div,
label {
  padding: 10px;
  font-style: inherit;
  margin-bottom: 0.5rem;
}

button {
  display: inline-block;
  border-radius: 0px;
  border: 0px solid #001a61;
  padding: 1rem 3rem;
  font-size: 1.2rem;
}

.toggle-group {
  margin-top: 1rem;
  border: 0px none #ccc;
}

.toggle__left {
  border-top-left-radius: 35px;
  border-bottom-left-radius: 35px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border: 0px hidden #ccc;
}

.toggle__right {
  border-top-right-radius: 35px;
  border-bottom-right-radius: 35px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border: 0px hidden #ccc;
}

.flex-container {
  display: flex;
}

.flex-child {
  flex: 1;
  display: flex;
}

.flex-child-child {
  flex: 1;
  border: 2px solid rgb(252, 252, 250);
  display: flex;
}

.fade-enter-active {
  transition: opacity 0.5s ease-in-out;
}

.fade-enter-from {
  opacity: 0;
}

.search-txt {
  margin-left: 0px;
  font-weight: bold;
}

@media (max-width: 768px) {
  .button-search {
    margin-left: 0rem;
  }

  .flex-container {
    flex-direction: column;
  }

  .toggle-group {
    margin-top: 0rem;
    margin-right: 0rem;
  }
}
</style>
